module.exports = __webpack_public_path__ + "static/media/productId-guide.0a74e7db.png";